/**
 * @param {Element} element
 * @param {{ duration: number?, inFrom?: "left" | "right"}} options
 * @returns {{ duration: number, css: (t: number) => string }}
 */
export function slideIn(element, options = { duration: 300, inFrom: "left" }) {
  const { duration = 300, inFrom = "left" } = options
  return {
    duration,
    css: (t) => {
      const difference = inFrom === "right" ? 1 - t : t - 1
      return `transform: translateX(${difference * 100}%); opacity: ${t}`
    }
  }
}
